import { FC, useEffect, useState } from "react";
import { LoaderTypeEnums, LoadingIndicator } from "@canei/app-components";
import { Auth } from "aws-amplify";

import { ILocalState, UserStateActionTypes } from "../../../@types/index.d";
import { useDispatch, useSelector } from "react-redux";
import { useApolloClient } from "@apollo/client";
import { Dispatch } from "redux";
import { ICurrentUserAction } from "../../../_lib/store/reducers/currentUser";

const Logout: FC = () => {
  const currentUser = useSelector(({ currentUser }: ILocalState) => currentUser);
  const dispatch = useDispatch<Dispatch<ICurrentUserAction>>();

  const [loggingOut, setLoggingOut] = useState(true);
  const client = useApolloClient();
  useEffect(() => {
    Auth.signOut().then(() => {
      setLoggingOut(false);
      dispatch({ type: UserStateActionTypes.CLEAR_STORE, payload: {} });
    });
  }, [currentUser, client, dispatch]);

  return loggingOut ? <LoadingIndicator type={LoaderTypeEnums.PAGE} /> : null;
};
export default Logout;
